import { render, staticRenderFns } from "./MbImageField.vue?vue&type=template&id=8455ef74"
import script from "./MbImageField.vue?vue&type=script&lang=js"
export * from "./MbImageField.vue?vue&type=script&lang=js"
import style0 from "./MbImageField.vue?vue&type=style&index=0&id=8455ef74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports